import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchManualPreadviceTransactionsDelete from '../../api/ManualPreadviceTransactionsDeleteAPI';
import { MPA_TRANSACTIONS_DELETE_REQUEST } from '../actions/types/ManualPreadviceTransactionsDeleteActionsTypes';
import { deleteManualPreadviceTransactionsDeleteSuccessActionCreator, deleteManualPreadviceTransactionsDeleteFailureActionCreator } from '../actions/ManualPreadviceTransactionsDeleteActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doMpaTransactionsDeleteWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchManualPreadviceTransactionsDelete, action.payload);
    yield put(deleteManualPreadviceTransactionsDeleteSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.manualpreadvicetransactions.delete.success'),
    }));
  } catch (error) {
    yield put(deleteManualPreadviceTransactionsDeleteFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doMpaTransactionsDeleteWatcher() {
  yield takeLatest(MPA_TRANSACTIONS_DELETE_REQUEST, doMpaTransactionsDeleteWorker);
}

export default doMpaTransactionsDeleteWatcher;
